/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Kreditportal Backend API
 * Das Kreditportal ermöglicht Versicherungsnehmern die Kautionsverträge einzusehen, anzupassen und Bürgschaften zu beantragen. Diese API ist eine Middleware fürs Frontend zu den Backend-Systemen.
 * OpenAPI spec version: 4.0.6-FINAL
 */
export interface SteuerberaterRelationData {
  /** @pattern [5][0-9]{8}[0]{4} */
  vsnr: string;
  /** @pattern [0-9]{1,13} */
  steuerberaterId: string;
}

export interface MaklerRelationData {
  /** @pattern [5][0-9]{8}[0]{4} */
  vsnr: string;
  /** @pattern [0-9]{1,9} */
  maklerId: string;
}

export interface LoggingRequest {
  name?: string;
  message?: string;
  stack?: string;
}

export interface TypedChangingEntityString {
  validationResult?: boolean;
  oldValue?: string;
  recentValue?: string;
  changed?: boolean;
}

export interface ChangeUserDataRequest {
  uid: string;
  name?: TypedChangingEntityString;
  surname?: TypedChangingEntityString;
  password?: TypedChangingEntityString;
  email?: TypedChangingEntityString;
}

export interface TypedEntityString {
  value: string;
  changeable?: boolean;
  validable?: boolean;
  nullable?: boolean;
}

export type TypedEntityKreditportalUserTypeValue = typeof TypedEntityKreditportalUserTypeValue[keyof typeof TypedEntityKreditportalUserTypeValue];


export const TypedEntityKreditportalUserTypeValue = {
  NONE: 'NONE',
  KP_KU_ADMIN: 'KP_KU_ADMIN',
  KP_KU_NUTZER: 'KP_KU_NUTZER',
  KP_MAKLER: 'KP_MAKLER',
  KP_STEUERBERATER: 'KP_STEUERBERATER',
} as const;

export interface TypedEntityKreditportalUserType {
  value: TypedEntityKreditportalUserTypeValue;
  changeable?: boolean;
  validable?: boolean;
  nullable?: boolean;
}

export interface TypedEntityBoolean {
  value: boolean;
  changeable?: boolean;
  validable?: boolean;
  nullable?: boolean;
}

export interface UserData {
  uid: TypedEntityString;
  fullName: TypedEntityString;
  name: TypedEntityString;
  surname: TypedEntityString;
  userType: TypedEntityKreditportalUserType;
  email?: TypedEntityString;
  gesperrt?: TypedEntityBoolean;
}

export interface ChangeUserDataResponse {
  isChanged: boolean;
  user?: UserData;
  name?: TypedChangingEntityString;
  surname?: TypedChangingEntityString;
  password?: TypedChangingEntityString;
  email?: TypedChangingEntityString;
}

export interface FindUsersResponse {
  vsnrWildcard?: string;
  userDataList: UserData[];
}

export interface NutzerAnlageRequest {
  /** @pattern [5][0-9]{8}[0]{4} */
  vsnr: string;
  /** @pattern ^5[0-9]{8}(000[2-9]|00[1-9][0-9]|0[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9]) */
  neueNutzerId: string;
  url: string;
  vorname: TypedChangingEntityString;
  nachname: TypedChangingEntityString;
  email: TypedChangingEntityString;
}

export interface NutzerAnlageResponse {
  erfolg?: boolean;
  vsnr?: string;
  neueNutzerId?: string;
  vorname?: TypedChangingEntityString;
  nachname?: TypedChangingEntityString;
  email?: TypedChangingEntityString;
}

export interface RegistrationVerifyRequestData {
  uuid: string;
}

export interface RegistrationVerifyUserRequest {
  uuid: string;
  /**
     * @minLength 12
     * @maxLength 40
     * @pattern ^(?=.*[0-9])(?=.*[A-Z\u00C0-\u00DD])(?=.*[a-z\u00DF-\u00FF])(?=.*[!?@(){}\[\]\\/=~$%&#*\-+.,_])(?!.* ).{12,40}$
     */
  password: string;
}

export interface RegistrationVerifyUserResponse {
  isSuccess: boolean;
  password?: TypedChangingEntityString;
}

export interface RegistrationCompleteRequestData {
  vorname: string;
  nachname: string;
  email: string;
  url: string;
  taskId: string;
  passwort?: TypedChangingEntityString;
}

export interface RegistrationCompleteResponse {
  completed: boolean;
  passwort?: TypedChangingEntityString;
}

export interface RegistrationRequestData {
  loginName: string;
  /**
     * @minLength 6
     * @maxLength 6
     */
  loginPin: string;
}

export interface RegistrationResponseData {
  taskId?: string;
}

export interface ChangeProfilDataRequest {
  ordnungsbegriff: string;
  archivDokument: string;
}

export interface ObligoRequest {
  vsnrs?: string[];
  datumVon?: string;
  datumBis?: string;
  benutzerId?: string;
  requiredFormat?: string;
  zipped?: boolean;
  onlyInRisk?: boolean;
}

export interface ObligoResponseEntry {
  fileName?: string;
  content?: string;
}

export interface ObligoResponse {
  lists?: ObligoResponseEntry[];
}

export type ErhoeheKreditlinieRequestModulAlt = typeof ErhoeheKreditlinieRequestModulAlt[keyof typeof ErhoeheKreditlinieRequestModulAlt];


export const ErhoeheKreditlinieRequestModulAlt = {
  START: 'START',
  STANDARD: 'STANDARD',
  SPEZIAL: 'SPEZIAL',
} as const;

export type ErhoeheKreditlinieRequestModulNeu = typeof ErhoeheKreditlinieRequestModulNeu[keyof typeof ErhoeheKreditlinieRequestModulNeu];


export const ErhoeheKreditlinieRequestModulNeu = {
  START: 'START',
  STANDARD: 'STANDARD',
  SPEZIAL: 'SPEZIAL',
} as const;

export interface ErhoeheKreditlinieRequest {
  vsnr?: string;
  aktuellerRahmen?: string;
  erhoehungsBeitrag?: string;
  modulAlt?: ErhoeheKreditlinieRequestModulAlt;
  modulNeu?: ErhoeheKreditlinieRequestModulNeu;
  erfassungsJahr?: string;
  firmenname?: string;
}

export interface JahresabschlussFinishRequest {
  user: string;
  roleName?: string;
  activeUser?: string;
  files: string[];
}

export interface CTAnlegenFirmenVerbundInput {
  adressOb?: string;
  firmenVerbund?: string;
  freigegebenFuer?: string;
}

export type BuergschaftsantragRequestBuergschaftsformat = typeof BuergschaftsantragRequestBuergschaftsformat[keyof typeof BuergschaftsantragRequestBuergschaftsformat];


export const BuergschaftsantragRequestBuergschaftsformat = {
  PAPIER: 'PAPIER',
  TRUSTLOG: 'TRUSTLOG',
  PDF: 'PDF',
} as const;

export interface BuergschaftsantragRequest {
  firma?: string;
  vorname?: string;
  nachname?: string;
  street?: string;
  plz?: string;
  ort?: string;
  vorwahl?: string;
  rufnummer?: string;
  email?: string;
  vertrag?: string;
  typeOfAntrag?: string;
  aenderungsAntragBuergscheinNummer?: string;
  auftraggeberTyp?: string;
  auftraggeberName?: string;
  auftraggeberStrasseNr?: string;
  auftraggeberPlz?: string;
  auftraggeberOrt?: string;
  auftraggeberLand?: string;
  vertretungsformel1?: string;
  vertretungsformel2?: string;
  vertretungsformel3?: string;
  vertretungsformel4?: string;
  vertretungsformel5?: string;
  buergschaftsArt?: string;
  ausfuehrungsbuergschaftenDatum?: string;
  vertragserfuellungsbuergschaftenDatum?: string;
  gewaehrleistungsbuergschaftenDatum?: string;
  schlussrechnungsDatum?: string;
  bietungsbuergschaftenDatum?: string;
  bauhandwerkersicherungssbuergschaftenDatum?: string;
  vorauszahlungsbuergschaftenDatum?: string;
  vertragsDatum?: string;
  vertragsnummer?: string;
  buergschaftshoehe?: string;
  prozentSatz?: string;
  befristet?: boolean;
  fristDatum?: string;
  gesetzlGrundlage?: string;
  checkboxHatBesondereHinweise?: boolean;
  besondereHinweise?: string;
  auftragsortGewerk?: string;
  auftragsortVerfuegbar?: string;
  auftragsortBeschreibung?: string;
  auftragsortStrasseNr?: string;
  auftragsortPlz?: string;
  auftragsortOrt?: string;
  buergschaftsformat?: BuergschaftsantragRequestBuergschaftsformat;
  erklaerungsDatum?: string;
  erklaerungsOrt?: string;
  erklaerungsName?: string;
  gewuenschtesFormular?: string;
  gewaehrleistungsfrist?: string;
  gewaehrleistungsfristJahre?: string;
  gewaehrleistungsfristMonate?: string;
  checkboxHinterlegung?: boolean;
  checkboxBGB768?: boolean;
  checkboxSGBVII150Abs3?: boolean;
  checkboxSGBIV28eAbs3a?: boolean;
  checkboxSicherheitseinbehalt?: boolean;
  checkboxAentG14?: boolean;
  checkboxErklaerungZustimmung?: boolean;
  auftraggeberSpKennung?: string;
  templateSpKennung?: string;
  roleName?: string;
  activeUser?: string;
  user?: string;
  files?: string[];
}

export type NachrichtArt = typeof NachrichtArt[keyof typeof NachrichtArt];


export const NachrichtArt = {
  AUSGESTELLT: 'AUSGESTELLT',
  INANSPRUCHNAHME: 'INANSPRUCHNAHME',
  ABGELEHNT: 'ABGELEHNT',
  KORREKTURANFORDERUNG: 'KORREKTURANFORDERUNG',
  ENTHAFTUNG: 'ENTHAFTUNG',
  TEILENTHAFTUNG: 'TEILENTHAFTUNG',
  RUECKFORDERUNG_ABLEHNUNG: 'RUECKFORDERUNG_ABLEHNUNG',
} as const;

export interface Nachricht {
  id: number;
  art: NachrichtArt;
  betreff: string;
  datum: string;
  gelesen: boolean;
  content: string;
}

export interface OrdnungsbegriffVSNR {
  vsnrNumerisch?: string;
  vsnrFormatiert?: string;
  pruefziffer?: string;
  versicherungszweigArt?: string;
  stammnummer?: string;
  geschaeftsstelle?: string;
}

export interface VertragHandle {
  vsnrNumerisch: string;
  vsnrFormatiert: string;
}

export interface VertragData {
  ordnungsbegriffVSNR?: OrdnungsbegriffVSNR;
  vertragHandle?: VertragHandle;
  vertragsart?: string;
  geschaeftsjahr?: number;
  rahmenBetrag?: number;
  rahmenBelastung?: number;
  buergscheinLimit?: number;
  sollStreuquote?: number;
  grundversorgungsbeitrag?: number;
  modul?: string;
  auslastungSublimit?: number;
  anzahlBuergscheine?: number;
  fehlerText?: string;
}

export type BuergscheinLightFassungsArt = typeof BuergscheinLightFassungsArt[keyof typeof BuergscheinLightFassungsArt];


export const BuergscheinLightFassungsArt = {
  AF: 'AF',
  VE: 'VE',
  MA: 'MA',
  VA: 'VA',
  BI: 'BI',
  BS: 'BS',
  UNKNOWN: 'UNKNOWN',
} as const;

export type BuergscheinLightVersandweg = typeof BuergscheinLightVersandweg[keyof typeof BuergscheinLightVersandweg];


export const BuergscheinLightVersandweg = {
  PAPIER: 'PAPIER',
  TRUSTLOG: 'TRUSTLOG',
  PDF: 'PDF',
} as const;

export type BuergscheinLightStatusanzeigeBuergschaft = typeof BuergscheinLightStatusanzeigeBuergschaft[keyof typeof BuergscheinLightStatusanzeigeBuergschaft];


export const BuergscheinLightStatusanzeigeBuergschaft = {
  IN_BEARBEITUNG: 'IN_BEARBEITUNG',
  AUSGESTELLT: 'AUSGESTELLT',
} as const;

export interface BuergscheinLight {
  buergscheinId?: string;
  fassungsArt?: BuergscheinLightFassungsArt;
  ausstellungsDatum?: string;
  fassungsBetrag?: number;
  auftraggeberInfo?: string;
  auftragInfo1?: string;
  versandweg?: BuergscheinLightVersandweg;
  buergschaftsStatus?: string;
  statusanzeigeBuergschaft?: BuergscheinLightStatusanzeigeBuergschaft;
  dokumentId?: string;
  originalDokumentId?: string;
}

export interface BuergscheinListe {
  anzahlBuergscheine?: number;
  buergscheine?: BuergscheinLight[];
}

export type BuergscheinBuergschaftsArt = typeof BuergscheinBuergschaftsArt[keyof typeof BuergscheinBuergschaftsArt];


export const BuergscheinBuergschaftsArt = {
  AF: 'AF',
  VE: 'VE',
  MA: 'MA',
  VA: 'VA',
  BI: 'BI',
  BS: 'BS',
  UNKNOWN: 'UNKNOWN',
} as const;

export interface Buergschein {
  vsnr?: string;
  buergscheinnummer?: string;
  ausstellungsdatum?: string;
  voraussichtlAblaufdatum?: string;
  buergschaftsArt?: BuergscheinBuergschaftsArt;
  befristungsDatum?: string;
  formularArt?: string;
  rechtsGrundlage?: string;
  buergschaftsBetrag?: number;
  auftraggeberinfo1?: string;
  auftraggeberinfo2?: string;
  auftraggeberinfo3?: string;
  auftraggeberinfo4?: string;
  auftraggeberinfo5?: string;
  auftraggeberinfo6?: string;
  auftragsdatum?: string;
  geschaeftszeichen?: string;
  auftrag1?: string;
  auftrag2?: string;
  auftrag3?: string;
  auftrag4?: string;
  auftrag5?: string;
  auftrag6?: string;
  gwFristMonate?: number;
  bspBuergschaftsstatus?: string;
  bspBuergschaftstextId?: string;
  bspUnternehmensId?: string;
}

export interface BuergscheinNummernResponse {
  buergscheinNummern?: string[];
}

export interface SteuerberaterKundeHandle {
  freigegeben?: boolean;
  vsnr: string;
  nameVn?: string;
}

export interface HandleListSteuerberaterKundeHandle {
  handles: SteuerberaterKundeHandle[];
}

export interface ServerDateTimeResponse {
  unixTimestampMs?: number;
}

export interface ConfigurationData {
  oauthUrl: string;
  oauthClientId: string;
  oauthRealmId: string;
  urlKautionProdukt: string;
  urlBuergscheinAntragBedingungenPdf: string;
  urlProduktvergleichStartStandardSpezial: string;
  footerTextCopyright: string;
  urlFooterWkvPortal: string;
  urlFooterImpressum: string;
  urlFooterDatenschutz: string;
  urlNeuenVertragAbschliessen: string;
  urlHilfe: string;
  urlInterneHilfe: string;
  produktivUmfeld: boolean;
}

export interface BeziehungenZuKundeResponse {
  maklerId?: number;
  steuerberaterId?: string;
}

export type AnschriftAllgemeinAnschriftType = typeof AnschriftAllgemeinAnschriftType[keyof typeof AnschriftAllgemeinAnschriftType];


export const AnschriftAllgemeinAnschriftType = {
  UNKNOWN: 'UNKNOWN',
  ANSCHRIFT_GROSSKUNDEN: 'ANSCHRIFT_GROSSKUNDEN',
  ANSCHRIFT_HAUS: 'ANSCHRIFT_HAUS',
  ANSCHRIFT_POSTFACH: 'ANSCHRIFT_POSTFACH',
  ANSCHRIFT_AUSLAND: 'ANSCHRIFT_AUSLAND',
  ANSCHRIFT_AUSLAND_STRUKTURIERT: 'ANSCHRIFT_AUSLAND_STRUKTURIERT',
} as const;

export interface AnschriftAllgemein {
  strasse?: string;
  plz?: string;
  ort?: string;
  ortZusatz?: string;
  postfach?: string;
  nationText?: string;
  nationSchluessel?: string;
  zeile1?: string;
  zeile2?: string;
  zeile3?: string;
  zeile4?: string;
  anschriftType: AnschriftAllgemeinAnschriftType;
  validationResult?: boolean;
}

export type TypedEntityRechtsfaehigkeitTypeValue = typeof TypedEntityRechtsfaehigkeitTypeValue[keyof typeof TypedEntityRechtsfaehigkeitTypeValue];


export const TypedEntityRechtsfaehigkeitTypeValue = {
  NONE: 'NONE',
  NATUERLICHE_PERSON: 'NATUERLICHE_PERSON',
  JURISTISCHE_PERSON: 'JURISTISCHE_PERSON',
} as const;

export interface TypedEntityRechtsfaehigkeitType {
  value: TypedEntityRechtsfaehigkeitTypeValue;
  changeable?: boolean;
  validable?: boolean;
  nullable?: boolean;
}

export type TypedEntityGeschlechtTypeValue = typeof TypedEntityGeschlechtTypeValue[keyof typeof TypedEntityGeschlechtTypeValue];


export const TypedEntityGeschlechtTypeValue = {
  UNBEKANNT: 'UNBEKANNT',
  MAENNLICH: 'MAENNLICH',
  WEIBLICH: 'WEIBLICH',
} as const;

export interface TypedEntityGeschlechtType {
  value: TypedEntityGeschlechtTypeValue;
  changeable?: boolean;
  validable?: boolean;
  nullable?: boolean;
}

export type TypedEntityAnredeTypeValue = typeof TypedEntityAnredeTypeValue[keyof typeof TypedEntityAnredeTypeValue];


export const TypedEntityAnredeTypeValue = {
  OHNE: 'OHNE',
  HERR: 'HERR',
  FRAU: 'FRAU',
  FIRMA: 'FIRMA',
} as const;

export interface TypedEntityAnredeType {
  value: TypedEntityAnredeTypeValue;
  changeable?: boolean;
  validable?: boolean;
  nullable?: boolean;
}

export interface TypedEntityAnschriftAllgemein {
  value: AnschriftAllgemein;
  changeable?: boolean;
  validable?: boolean;
  nullable?: boolean;
}

export interface PartnerProfilData {
  externePartnerId?: TypedEntityString;
  externePartnerIdAufbereitet?: TypedEntityString;
  rechtsfaehigkeitType?: TypedEntityRechtsfaehigkeitType;
  geschlechtType?: TypedEntityGeschlechtType;
  anredeType?: TypedEntityAnredeType;
  nachnameOderName1?: TypedEntityString;
  vornameOderName2?: TypedEntityString;
  name3?: TypedEntityString;
  name4?: TypedEntityString;
  anschriftAllgemein?: TypedEntityAnschriftAllgemein;
  email?: TypedEntityString;
  telefonnummer?: TypedEntityString;
}

export interface ObligoJahreResponse {
  anzahlJahre?: number;
  jahre?: number[];
}

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];


export const NotificationType = {
  info: 'info',
  warning: 'warning',
  error: 'error',
  fatal: 'fatal',
  help: 'help',
  urgent: 'urgent',
} as const;

export interface Notification {
  type?: NotificationType;
  message?: string;
  targetURI?: string;
  visibleFrom?: string;
  visibleUntil?: string;
}

export interface NotificationsResponse {
  messages: Notification[];
}

export type NachrichtMetadataArt = typeof NachrichtMetadataArt[keyof typeof NachrichtMetadataArt];


export const NachrichtMetadataArt = {
  AUSGESTELLT: 'AUSGESTELLT',
  INANSPRUCHNAHME: 'INANSPRUCHNAHME',
  ABGELEHNT: 'ABGELEHNT',
  KORREKTURANFORDERUNG: 'KORREKTURANFORDERUNG',
  ENTHAFTUNG: 'ENTHAFTUNG',
  TEILENTHAFTUNG: 'TEILENTHAFTUNG',
  RUECKFORDERUNG_ABLEHNUNG: 'RUECKFORDERUNG_ABLEHNUNG',
} as const;

export interface NachrichtMetadata {
  id: number;
  art: NachrichtMetadataArt;
  betreff: string;
  datum: string;
  gelesen: boolean;
}

export interface NachrichtenSimpleResponse {
  nachrichten?: NachrichtMetadata[];
}

export interface MaklerKundeHandle {
  freigegeben?: boolean;
  vsnr: string;
  nameVn?: string;
}

export interface HandleListMaklerKundeHandle {
  handles: MaklerKundeHandle[];
}

export interface FirmenverbundMitglied {
  kundennummer?: string;
  name?: string;
  zugriffGewaehrt?: boolean;
  zugriffErhalten?: boolean;
}

export interface Firmenverbund {
  verbundNr?: string;
  verbundName?: string;
  mitglieder?: FirmenverbundMitglied[];
}

export interface DownloadEntity {
  id?: string;
  url?: string;
  fileName?: string;
  headline?: string;
  description?: string;
  userBitmask?: number;
  fileSize?: number;
  type?: string;
}

export interface DownloadSections {
  headline?: string;
  path?: string;
  entities?: DownloadEntity[];
}

export interface DownloadCollection {
  sections?: DownloadSections[];
}

export interface CTKunde {
  vsnr?: string;
  nameVN?: string;
  fvnr?: number;
  freigegeben?: boolean;
}

export interface CTErmittleFirmenVerbundOutput {
  jpnr?: number;
  verbundName: string;
  anzahl?: number;
  kunde?: CTKunde[];
}

export interface Auftraggeber {
  spKennung?: string;
  name?: string;
  strasse?: string;
  plz?: string;
  ort?: string;
  landeskennzeichen?: string;
  vertrittOeffentlicheRessorts?: boolean;
}

export type BuergschaftsTemplateBuergschaftsart = typeof BuergschaftsTemplateBuergschaftsart[keyof typeof BuergschaftsTemplateBuergschaftsart];


export const BuergschaftsTemplateBuergschaftsart = {
  AF: 'AF',
  VE: 'VE',
  MA: 'MA',
  VA: 'VA',
  BI: 'BI',
  BS: 'BS',
  UNKNOWN: 'UNKNOWN',
} as const;

export interface BuergschaftsTemplate {
  spKennung?: string;
  templatetyp?: string;
  buergschaftsart?: BuergschaftsTemplateBuergschaftsart;
  befristung?: boolean;
  gueltigAb?: string;
  gueltigBis?: string;
  beschreibungAuftraggeber?: string;
  recht?: string;
  templateTypOeffentlich?: string;
  contentLength?: number;
}

export interface TemplateSucheResponse {
  templates?: BuergschaftsTemplate[];
  size: number;
}

export interface AuftraggeberSucheResponse {
  auftraggeber?: Auftraggeber[];
  numFoundAuftraggeber?: number;
  numRemainingAuftraggeber?: number;
}

export interface NutzerLoeschenRequest {
  /** @pattern [5][0-9]{8}[0]{4} */
  vsnr: string;
  /** @pattern ^5[0-9]{8}(000[2-9]|00[1-9][0-9]|0[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9]) */
  nutzerId: string;
}

export type PutFirmenverbundFreigabeGewaehrenParams = {
kundennummerMandatempfaenger: string;
};

export type DeleteFirmenverbundFreigabeEntziehenParams = {
kundennummerEntzug: string;
};

export type PostJahresabschlussParams = {
user: string;
activeUser: string;
roleName: string;
};

export type PostJahresabschlussBody = {
  uploadFile: Blob;
};

export type PostFirmenverbundEinspringenParams = {
kundennummer: string;
};

export type AnlegenFirmenverbundParams = {
ctAnlegenFirmenVerbundInput: CTAnlegenFirmenVerbundInput;
};

export type PostBuergschaftsantragTemplateUploadParams = {
user: string;
activeUser: string;
roleName: string;
};

export type PostBuergschaftsantragTemplateUploadBody = {
  uploadFile: Blob;
};

export type SetGelesenStatusParams = {
isGelesen: boolean;
};

export type GetBuergscheineParams = {
geschaeftsjahr?: string;
startBuergscheinnummer?: number;
};

export type GetBuergscheinDokumentParams = {
original?: boolean;
};

export type GetVertraegeDataParams = {
/**
 * @minItems 0
 * @maxItems 1000
 */
vsnrs?: string[];
};

export type GetNachrichtenByVsnrsParams = {
/**
 * @minItems 0
 * @maxItems 1000
 */
vsnrs?: string[];
};

export type GetJsonFile200 = { [key: string]: unknown };

export type ErmittleFirmenverbundParams = {
vsnr?: string;
jpnr?: number;
firmenVerbund?: string;
};

export type TemplateSucheParams = {
trustlogAgKennung: string;
buergschaftsart?: TemplateSucheBuergschaftsart;
vertragsdatum?: string;
};

export type TemplateSucheBuergschaftsart = typeof TemplateSucheBuergschaftsart[keyof typeof TemplateSucheBuergschaftsart];


export const TemplateSucheBuergschaftsart = {
  AF: 'AF',
  VE: 'VE',
  MA: 'MA',
  VA: 'VA',
  BI: 'BI',
  BS: 'BS',
  UNKNOWN: 'UNKNOWN',
} as const;

export type AuftraggeberSucheParams = {
name: string;
plz?: string;
limit?: boolean;
};

